// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.misConfirmModal__wQ6FS {
  height: 464px;
  width: 372px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.modalBody__uaBV2 {
  height: 100%;
  flex: 1;
  flex-direction: column;
  align-items: center;
  padding: 35px 30px 0;
}

.confirmText__ZYvdP {
  font-size: 16px;
  line-height: 21px;
  color: var(--tables-secondary-row-sub-title-text);
  text-align: center;
}
.confirmText__ZYvdP b {
  color: var(--tables-primary-row-text-main);
  font-weight: 500;
}

.checkboxWrapper__bjYWt {
  margin-top: 15px;
  display: flex;
  justify-content: center;
}

.modalFooter__NZ9XL {
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin-top: 30px;
  padding: 0 51px 35px;
}`, "",{"version":3,"sources":["webpack://./../src/components/modals/ReplaceSensorMisConfirmModal/style.module.scss"],"names":[],"mappings":"AA0EA;EACE,aAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;AAzEF;;AA4EA;EACE,YAAA;EACA,OAAA;EACA,sBAAA;EACA,mBAAA;EACA,oBAAA;AAzEF;;AA4EA;EACE,eAAA;EACA,iBAAA;EACA,iDAAA;EACA,kBAAA;AAzEF;AA2EE;EACG,0CAAA;EACD,gBAAA;AAzEJ;;AA6EA;EACE,gBAAA;EACA,aAAA;EACA,uBAAA;AA1EF;;AA6EA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,gBAAA;EACA,oBAAA;AA1EF","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.misConfirmModal {\n  height: 464px;\n  width: 372px;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n}\n\n.modalBody {\n  height: 100%;\n  flex: 1;\n  flex-direction: column;\n  align-items: center;\n  padding: 35px 30px 0;\n}\n\n.confirmText {\n  font-size: 16px;\n  line-height: 21px;\n  color: var(--tables-secondary-row-sub-title-text);\n  text-align: center;\n\n  b {\n     color: var(--tables-primary-row-text-main);\n    font-weight: 500;\n  }\n}\n\n.checkboxWrapper {\n  margin-top: 15px;\n  display: flex;\n  justify-content: center;\n}\n\n.modalFooter {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  margin-top: 30px;\n  padding: 0 51px 35px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"misConfirmModal": `misConfirmModal__wQ6FS`,
	"modalBody": `modalBody__uaBV2`,
	"confirmText": `confirmText__ZYvdP`,
	"checkboxWrapper": `checkboxWrapper__bjYWt`,
	"modalFooter": `modalFooter__NZ9XL`
};
module.exports = ___CSS_LOADER_EXPORT___;
